
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/application-development/page/[id]",
      function () {
        return require("private-next-pages/cases/application-development/page/[id].tsx");
      }
    ]);
  